import React, { useEffect, useMemo } from 'react'
import BreadCrumb from "../../../components/common/BreadCrumb";
import { Link, useNavigate } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Row, Button } from "react-bootstrap";
import { TableResponsive } from "../../../components/common/TableResponsive";
import { ViewEnquiryModal } from './ViewEnquiryModal';
import { UpateEnquiryModal } from './UpateEnquiryModal';
import { NewEnquiryModal } from './NewEnquiryModal';
import { FeedbackModal } from './FeedbackModal';
import { useDispatch, useSelector } from 'react-redux';
import { enquiry, ASSET_URL } from '../../../helper/api_url';
import { formatDate } from '../../../helper/formatDate';
import { usePageInitialtor } from '../../../helper/custom_hook';
import ImageViewer from '../../../components/ImageViewer';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { swal } from '../../../helper/swal';
import Swal from 'sweetalert2';
import { setPreloader } from '../../../features/Ui/uiSlice';
function Enquiry() {
    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const dispatch = useDispatch();
    const authData = useSelector(state => state.auth._user);
    const handleEnquiryDelete = (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
        }).then((result) => {
            dispatch(setPreloader({ loader: true, message: 'please wait ... ' }));
            if (result.isConfirmed) {
                enquiry.delete(id).then(() => {
                    queryClient.invalidateQueries(['enquirys']);
                }).catch((err) => {
                    swal.error(err.response ? err.response.data.message : err.message)
                }).finally(() => {
                    dispatch(setPreloader({ loader: false, message: "" }));
                })
            }
        })
    }
    // Fetch users
    const { data: enquirys = [], isLoading, isError, error } = useQuery({
        queryKey: ['enquirys'],
        queryFn: enquiry.list,
        staleTime: 20 * 60 * 1000, // 20 minutes
        cacheTime: 20 * 60 * 1000, // 20 minutes
        select: (data) => data?.data?.enquiry
    });
    useEffect(() => { if (isError && error) { swal.error(error.response?.data.message || error.message); } }, [isError, error]);
    useEffect(() => { if (isError) swal.error(error.response ? error.response.data.message : error.message) }, [isError, error])
    const handleReport = (data) => {
        navigate('/report', { state: { data } });
    }
    const columns = useMemo(() => [
        {
            Header: "School Name",
            accessor: "name",
            HeaderClass: '',
            DataClass: '',
            Cell: (cell) => {
                const imageUrl = ASSET_URL + cell.row.original.avatar;
                const trial_end = cell.row.original.tryal_date != null ? new Date(cell.row.original.tryal_date) : null;
                if (trial_end != null) trial_end.setDate(trial_end.getDate() + cell.row.original.tryal_period);
                return (
                    <ImageViewer image={imageUrl}>
                        <span>
                            <img className="me-2 rounded-circle header-profile-user" style={{ objectFit: 'cover' }} src={imageUrl} alt="User Avatar" />
                            {cell.row.original.name}
                            {(trial_end != null)
                                ? (trial_end > Date.now()
                                    ? (<span className='badge badge-soft-success px-1 ms-1'>On Trail</span>)
                                    : (<span className='badge badge-soft-danger px-1 ms-1'>Trail Expired</span>))
                                : null}
                        </span>
                    </ImageViewer>
                )
            }
        },
        { Header: 'Prefered Service', accessor: 'course.name', DataClass: 'bg-soft-warning text-center p-0', HeaderClass: 'text-center' },
        { Header: 'Phone', accessor: 'phone' },
        {
            Header: "Enquiry By",
            Cell: (cell) => {
                return (<span>{cell?.row?.original?.created_by?.first_name} {cell?.row?.original?.created_by?.last_name}</span>)
            }
        },
        {
            Header: "Date",
            Cell: (cell) => {
                return (<span>{formatDate(cell.row.original.created_at)}</span>)
            }
        },
        {
            Header: 'Status',
            HeaderClass: 'text-center',
            DataClass: 'text-center',
            Cell: (cell) => {
                const row = cell.row.original.status;
                const status = {
                    label: row == "other" ? "Not Instrested" : row,
                    classStatus: row == "pending" ? "warning" : (row === "completed" ? "success" : "danger")
                }
                return (<span className={`badge badge-outline-${status.classStatus}`}>{status.label}</span>)
            }
        },
        {
            Header: "Report",
            HeaderClass: authData.role.priority >= 50 ? 'text-center' : 'd-none',
            DataClass: authData.role.priority >= 50 ? 'text-center' : 'd-none',
            Cell: (cell) => {
                const row = cell.row.original;
                return (<button className='btn btn-sm btn-soft-info add-btn waves-effect' onClick={() => handleReport(row)}><i className="bx bx-history align-bottom mb-1 me-1" />Report</button>)
            }
        },
        {
            Header: "Action",
            HeaderClass: 'text-center',
            DataClass: 'text-center',
            Cell: (cell) => {
                return (
                    <div className="">

                        <ViewEnquiryModal view={cell.row.original} />

                        <UpateEnquiryModal data={cell.row.original} apiHandler={enquirys} />

                        <Button onClick={() => handleEnquiryDelete(cell.row.original.id)} className="btn btn-sm btn-soft-danger me-1" >
                            <i className="ri-delete-bin-fill" />
                        </Button>
                    </div>
                )
            },
        },
        {
            Header: 'List',
            HeaderClass: 'd-none',
            DataClass: 'd-none',
            listClass: 'list-group-item border-0 px-0 bg-transparent',
            list: (row) => {
                const imageUrl = ASSET_URL + row.avatar;
                const trial_end = row.tryal_date != null ? new Date(row.tryal_date) : null;
                if (trial_end != null) trial_end.setDate(trial_end.getDate() + row.tryal_period);
                const rowStatus = row.status;
                const statusLabel = rowStatus === "other" ? "Not Interested" : rowStatus;
                const statusClass = rowStatus === "pending" ? "warning" : (rowStatus === "completed" ? "success" : "danger");
                const createdByName = row.created_by
                    ? `${row.created_by.first_name} ${row.created_by.last_name || ''}`.trim()
                    : 'System';

                return (
                    <div className="card shadow-sm border border-light rounded-3 mb-3 w-100">
                        <div className="card-body p-3">
                            {/* Card Header: Avatar, Name, Service Tag and Trial status */}
                            <div className="d-flex align-items-start justify-content-between mb-2">
                                <div className="d-flex align-items-center">
                                    <ViewEnquiryModal view={row}>
                                        <div style={{ cursor: 'pointer' }}>
                                            <img
                                                className="me-2 rounded-circle border"
                                                style={{ width: "42px", height: "42px", objectFit: 'cover' }}
                                                src={imageUrl}
                                                alt="User Avatar"
                                            />
                                        </div>
                                    </ViewEnquiryModal>
                                    <div>
                                        <h6 className="fs-14 mb-0 fw-semibold">
                                            <ViewEnquiryModal view={row}>
                                                <span className="text-primary link-primary" style={{ cursor: 'pointer' }}>{row.name}</span>
                                            </ViewEnquiryModal>
                                        </h6>
                                        <div className="d-flex flex-wrap gap-1 mt-1 align-items-center">
                                            {row.course?.name && (
                                                <span className="badge bg-soft-info text-info fs-10 px-2 py-0.5">
                                                    {row.course.name}
                                                </span>
                                            )}
                                            {trial_end != null && (
                                                trial_end > Date.now()
                                                    ? (<span className='badge badge-soft-success fs-10 px-2 py-0.5'>On Trial</span>)
                                                    : (<span className='badge badge-soft-danger fs-10 px-2 py-0.5'>Trail Expired</span>)
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <span className={`badge badge-outline-${statusClass} px-2 py-1 fs-10 text-capitalize`}>
                                    {statusLabel}
                                </span>
                            </div>

                            {/* Details Row: Phone, Enquiry By, Date, and Feedback */}
                            <div className="py-2 border-top border-bottom border-light my-2">
                                <div className="row g-2">
                                    <div className="col-6">
                                        <small className="text-muted d-block fs-11">Phone</small>
                                        <a href={`tel:${row.phone}`} className="text-success fs-12 fw-semibold d-inline-flex align-items-center">
                                            <i className="bx bx-phone me-1 fs-14" />
                                            {row.phone}
                                        </a>
                                    </div>
                                    <div className="col-6">
                                        <small className="text-muted d-block fs-11">Enquiry By</small>
                                        <span className="text-dark fs-12 fw-medium text-truncate d-block">
                                            <i className="ri-user-line me-1 text-muted fs-12" />
                                            {createdByName}
                                        </span>
                                    </div>
                                    <div className="col-6">
                                        <small className="text-muted d-block fs-11">Created Date</small>
                                        <span className="text-muted fs-12 d-inline-flex align-items-center">
                                            <i className="ri-calendar-2-line me-1 fs-12" />
                                            {formatDate(row.created_at)}
                                        </span>
                                    </div>
                                    <div className="col-6 d-flex align-items-end justify-content-start">
                                        <FeedbackModal feedback={row.feedback} schoolName={row.name}>
                                            <span className="btn btn-sm btn-soft-primary px-2 py-0.5 fs-11 d-inline-flex align-items-center gap-1">
                                                <i className="ri-chat-3-line fs-12" />
                                                <span>Feedback</span>
                                            </span>
                                        </FeedbackModal>
                                    </div>
                                </div>
                            </div>

                            {/* Actions Footer */}
                            <div className="d-flex align-items-center justify-content-between pt-1">
                                <div>
                                    {authData.role.priority >= 50 && (
                                        <button className='btn btn-sm btn-soft-info waves-effect d-inline-flex align-items-center py-1' onClick={() => handleReport(row)}>
                                            <i className="bx bx-history me-1 fs-12" />
                                            <span>Report</span>
                                        </button>
                                    )}
                                </div>
                                <div className="d-flex gap-1 align-items-center">
                                    <ViewEnquiryModal view={row} />
                                    <UpateEnquiryModal data={row} apiHandler={enquirys} />
                                    <Button onClick={() => handleEnquiryDelete(row.id)} className="btn btn-sm btn-soft-danger py-1 px-2 d-inline-flex align-items-center justify-content-center" style={{ height: '28px' }}>
                                        <i className="ri-delete-bin-fill fs-12" />
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }
        }
    ], [enquirys]);

    return (
        <>
            <BreadCrumb title="Users" prevPage="Home" prevPath="/dashboard" />
            <Row>
                <Col xs={12}>
                    <Card>
                        <CardHeader className="d-flex align-items-center justify-content-between">
                            <h5 className="card-title mb-0">Enquiry List</h5>
                            {/* <NewEnquiryModal apiHandler={enquirys} /> */}
                            <Link to={'/create-enquiry'} className='btn btn-soft-success add-btn waves-effect'>
                                <i className="ri-add-line align-bottom me-1"></i>
                                <span>Add Enquiry</span>
                            </Link>
                        </CardHeader>
                        <CardBody className="">
                            <TableResponsive isLoading={isLoading} columns={columns} data={enquirys} noRecord="No Record Enquiry List" />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </>
    )
}

export default Enquiry